import request from '@/util/request'

export function getAllCompany(query) {
  return request({
    url: '/logistics/allCompany',
    method: 'get',
    params: query,
  })
}

export function addCompany(data) {
  return request({
    url: '/logistics/addCompany',
    method: 'post',
    data,
  })
}

export function deleteCompany(data) {
  return request({
    url: '/logistics/deleteCompany',
    method: 'post',
    data,
  })
}

export function amendCompany(data) {
  return request({
    url: '/logistics/amendCompany',
    method: 'post',
    data,
  })
}

export function setCompanyDefault(data) {
  return request({
    url: '/logistics/setDefault',
    method: 'post',
    data,
  })
}
